import { render, staticRenderFns } from "./ExternalClientsList.vue?vue&type=template&id=e882f5f2&"
import script from "./ExternalClientsList.vue?vue&type=script&lang=ts&"
export * from "./ExternalClientsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QInput,QIcon,QList} from 'quasar'
component.options.components = Object.assign({QInput,QIcon,QList}, component.options.components || {})
